/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import { Route, Switch } from 'react-router-dom'

import CreateCampaignForm from 'Containers/CreateCampaignPage'

import { campaignsList, createCampaign } from '../../routes'

const CreateCampaignComponents = () => (
  <Switch>
    <Route
      component={CreateCampaignForm}
      exact
      path={`${campaignsList}${createCampaign}`}
    />
  </Switch>
)

export default CreateCampaignComponents
